import React, { useEffect } from 'react'
import { createBrowserHistory } from 'history'
import Unauthorized from './components/Unauthorized'
import StartPage from 'pages/Start/start'
import FleetpanPage from 'pages/Fleetpan/FleetPanPage'
import WorkPackage from 'pages/WorkPackage/WorkPackagePage'
import OrdersPage from 'pages/Orders/OrdersPage'
import OrderValidationPage from 'pages/Orders/OrderValidationPage'
import TechlogSearchPage from 'pages/Techlog/TechlogSearchPage'
import TechlogPage from 'pages/Techlog/TechlogPage'
import WorkorderPage from 'pages/WorkOrder/WorkorderPage'
import './App.css'
import { Routes, Route } from 'react-router-dom'
import UrlApis from './utils/api/urlApis'
import axios from './utils/api/axios'
import AxiosUtils from './utils/api/axiosUtils'
import { HTTP_CODES } from './constants/constants'
import LocalStorage from './utils/myLocalStorage'

import Layout from './Layout'
import StockPage from 'pages/Stock/StockPage'

function App() {
  const baseUrl = process.env.PUBLIC_URL

  const appHistory = createBrowserHistory()

  /**
   * Fetching path to customer's logo image and saving it locally for future reference
   */
  const loadCustomerlogo = async () => {
    try {
      console.debug('Root-component <App> :: called URL = ' + encodeURI(UrlApis.URL_COMMON_CUSTOMER_LOGO_GET))
      const headerCompleted = await AxiosUtils.getHeader(AxiosUtils.HEADERS.HEADER_READ)
      const response = await axios.get(
        encodeURI(UrlApis.URL_COMMON_CUSTOMER_LOGO_GET),
        {},
        {
          headers: headerCompleted,
          withCredentials: false,
        },
      )

      // Stores path to customer logo
      console.debug("path to customer's logo retrieved <App>")
      LocalStorage.put([LocalStorage.KEY_PARAMS_PATH_CUSTOMER_LOGO], response?.data)
      /* Tip: we update the browser history to force the components to reload:
       ** we especially want the customer icon to be loaded (refreshed) in the login modal */
      appHistory.push('/amasis-web/')
      appHistory.back()
    } catch (err) {
      console.debug('ERR <App>: ' + err)
      if (err.response.status === HTTP_CODES.HTTP_CODE_NOT_FOUND) {
        // Mute: no message
      } else {
        // Mute: no message displayed
      }
    }
  }

  useEffect(() => {
    loadCustomerlogo()
  }, [])

  return (
    <Routes history={appHistory}>
      <Route path={baseUrl} element={<Layout />}>
        <Route index element={<StartPage />} />
        {/* <Route path='*' element={<Unauthorized />} /> */}
      </Route>
      <Route exact path='/amasis-web/fleetpan' element={<Layout />}>
        <Route path=':avimmatr?'>
          <Route index element={<FleetpanPage />} />
          <Route path='new'>
            <Route index element={<TechlogPage />} />
          </Route>
          <Route path=':workorder'>
            <Route index element={<WorkorderPage />} />
          </Route>
          <Route path=':rmdate/:rmdoc'>
            <Route index element={<TechlogPage />} />
            <Route path='new' element={<WorkorderPage />} />
            <Route path=':workorder' element={<WorkorderPage />} />
          </Route>
        </Route>
      </Route>
      <Route path='/amasis-web/workpackage' element={<Layout />}>
        <Route path=':bdvnumdoc?' element={<WorkPackage />} />
        <Route path='wo/:workorder' element={<WorkorderPage />} />
      </Route>
      <Route path='/amasis-web/orders' element={<Layout />}>
        <Route index element={<OrdersPage />} />
        <Route path=':cdnumdoc' element={<OrderValidationPage />} />
      </Route>
      <Route path='/amasis-web/techlogs' element={<Layout />}>
        <Route index element={<TechlogSearchPage />} />
        <Route path=':avimmatr'>
          <Route path='new'>
            <Route index element={<TechlogPage />} />
          </Route>
          <Route path=':rmdate/:rmdoc'>
            <Route index element={<TechlogPage />} />
            <Route path='new' element={<WorkorderPage />} />
            <Route path=':workorder' element={<WorkorderPage />} />
          </Route>
        </Route>
      </Route>
      <Route path='/amasis-web/workorders' element={<Layout />}>
        <Route path=':workorder' element={<WorkorderPage />} />
      </Route>
      <Route path='/amasis-web/stocks' element={<Layout />}>
        <Route index element={<StockPage />} />
      </Route>
      <Route path='/amasis-web/*' element={<Unauthorized />} />
    </Routes>
  )
}

export default App
